export default "__VITE_ASSET__04696d77__"